import { useCallback, useState } from "react";

type SortAccessor<T> = keyof T | ((item: T) => unknown);

const useStateSorted = <T>(defaultValue: T[], sortAccessor: SortAccessor<T>) => {
  const [state, setState] = useState<T[]>(defaultValue);

  const setSortedState = useCallback((items: T[]) => {
    if (!items) {
      setState(null);
      return;
    }

    const sorted = [...items].sort((a, b) => {
      const aVal = typeof sortAccessor === "function" ? sortAccessor(a) : a[sortAccessor];
      const bVal = typeof sortAccessor === "function" ? sortAccessor(b) : b[sortAccessor];

      if (typeof aVal === "string" && typeof bVal === "string") {
        return aVal.localeCompare(bVal);
      }

      return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    });

    setState(sorted);
  }, [sortAccessor]);

  return [state, setSortedState] as const;
};

export default useStateSorted;
